import React from "react";
import classNames from "classnames";
import PostCard from "../postCard/PostCard";
import {useRouter} from "next/router";
import styles from "./LastNews.module.scss";
import postStyles from "../postCard/PostCard.module.scss";

const LastNews = React.forwardRef(
  function LastNews({list}, ref) {
    const router = useRouter();


    const items = list?.slice(0, 5).map((item, index) => (
      <PostCard key={`item-${index}`}
                {...item}
                isFetchpriority={index < 3}
                color={true && index === 0}
                tagsColor={true}
                type={"lastNews"}
                author={false}
                time={index === 0 ? item?.time : false}
                className={classNames(styles.lastNews__item,
                  postStyles.postCard_lastNews,
                  {
                    [styles.lastNews__item_big]: index === 0,
                    [postStyles.postCard_lastNews]: index !== 0,
                    [postStyles.postCard_lastNewsBig]: index === 0,
                  })}
                onClick={() => router.push(item.href)}
      />
    ));

    return (
      <section className={classNames(styles.lastNews)} ref={ref}>
        <div className={styles.lastNews__content}>
          <div className={styles.lastNews__list}>
            {items}
          </div>
        </div>

      </section>
    );
  });
export default LastNews;
LastNews.propTypes = {};

